var map = {
	"./avatar.JPG": 8315,
	"./chat/photo1.png": 4789,
	"./chat/photo2.png": 2990,
	"./geez/photo1.png": 2544,
	"./geez/photo2.png": 187,
	"./geez/photo3.png": 2706,
	"./geez/photo4.png": 6957,
	"./geez/photo5.png": 3924,
	"./geez/photo6.png": 4767,
	"./geez/photo7.png": 5750,
	"./geez/photo8.png": 945,
	"./getFood/photo1.png": 8407,
	"./getFood/photo10.png": 5719,
	"./getFood/photo11.png": 5726,
	"./getFood/photo12.png": 4501,
	"./getFood/photo13.png": 636,
	"./getFood/photo2.png": 828,
	"./getFood/photo3.png": 6741,
	"./getFood/photo4.png": 6314,
	"./getFood/photo5.png": 8227,
	"./getFood/photo6.png": 2616,
	"./getFood/photo7.png": 3745,
	"./getFood/photo8.png": 5878,
	"./getFood/photo9.png": 7423,
	"./icons/Ai.svg": 624,
	"./icons/Automation.svg": 2487,
	"./icons/Data.svg": 6961,
	"./icons/Database.svg": 2109,
	"./icons/Github.svg": 2659,
	"./icons/Instagram.svg": 4438,
	"./icons/Linkedin.svg": 328,
	"./icons/Machine.svg": 5609,
	"./icons/Mail.svg": 5067,
	"./icons/Return.svg": 348,
	"./icons/Server.svg": 6159,
	"./icons/Spring.svg": 3069,
	"./jsons/about.en": 3676,
	"./jsons/about.en.json": 3676,
	"./jsons/about.tr": 4617,
	"./jsons/about.tr.json": 4617,
	"./jsons/contact.en": 3843,
	"./jsons/contact.en.json": 3843,
	"./jsons/contact.tr": 2758,
	"./jsons/contact.tr.json": 2758,
	"./jsons/portfolio.en": 8115,
	"./jsons/portfolio.en.json": 8115,
	"./jsons/portfolio.tr": 7670,
	"./jsons/portfolio.tr.json": 7670,
	"./jsons/profile.en": 9240,
	"./jsons/profile.en.json": 9240,
	"./jsons/profile.tr": 5101,
	"./jsons/profile.tr.json": 5101,
	"./jsons/resume.en": 4902,
	"./jsons/resume.en.json": 4902,
	"./jsons/resume.tr": 163,
	"./jsons/resume.tr.json": 163,
	"./mailApi/photo1.png": 6866,
	"./mailApi/photo2.png": 873,
	"./mailApi/photo3.png": 5120,
	"./mailApi/photo4.png": 991,
	"./mailApi/photo5.png": 5894,
	"./mailApi/photo6.png": 9661,
	"./pleya/photo1.png": 5586,
	"./pleya/photo10.png": 4680,
	"./pleya/photo2.png": 1673,
	"./pleya/photo3.png": 5424,
	"./pleya/photo4.png": 1295,
	"./pleya/photo5.png": 2278,
	"./pleya/photo6.png": 9837,
	"./pleya/photo7.png": 6804,
	"./pleya/photo8.png": 2099,
	"./pleya/photo9.png": 6890,
	"./rente/photo1.png": 7745,
	"./rente/photo2.png": 6634,
	"./rente/photo3.png": 739,
	"./rente/photo4.png": 4492,
	"./rente/photo5.png": 6757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1089;